// extracted by mini-css-extract-plugin
module.exports = {"header":"KLineH5_header__qXrZy","wrapper":"KLineH5_wrapper__GVAWr","orderbook":"KLineH5_orderbook__7dvfF","bidHeader":"KLineH5_bidHeader__Ym2dE","tabs":"KLineH5_tabs__hmGSS"};